import React from "react";
import loadable from "@loadable/component";
import GoogleSignupButton from "../GoogleSignupButton";

export default loadable(() => import(/* webpackChunkName: 'google_signup' */ "../GoogleSignup"), {
    fallback: <GoogleSignupButton />,
});
